
// Premium motion: Lenis smooth scroll + GSAP scroll reveals, with graceful fallbacks
document.addEventListener('DOMContentLoaded', function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;

  if(window.Lenis){
    var lenis = new Lenis({ lerp: 0.11 });
    var raf = function(time){ lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  }

  var targets = document.querySelectorAll(
    '.section-heading, .product-card, .split__content, .split__media, .browse-card, .learn-card, .faq-item, .newsletter, .photo-slider__head, .photo-slider__track .slide, .gallery__item'
  );

  if(window.gsap && window.ScrollTrigger){
    gsap.registerPlugin(ScrollTrigger);
    if(window.Lenis && typeof lenis !== 'undefined'){
      lenis.on('scroll', ScrollTrigger.update);
    }
    targets.forEach(function(el, i){
      gsap.fromTo(el,
        { y: 36, opacity: 0 },
        { y: 0, opacity: 1, duration: .9, ease: 'power3.out', delay: (i % 4) * .07,
          scrollTrigger: { trigger: el, start: 'top 90%' } });
    });
    document.querySelectorAll('.split__media img, .browse-card img').forEach(function(img){
      gsap.set(img, { scale: 1.12 });
      gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: img.parentElement, scrub: true } });
    });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '-8% 0px' });
    targets.forEach(function(el){ el.classList.add('reveal--css'); io.observe(el); });
  }
});

// Dismissible announcement bar (remembers per-message)
document.addEventListener('DOMContentLoaded', function(){
  var bar = document.querySelector('[data-announcement]');
  if(bar){
    var key = 'elvtd-announcement-' + bar.dataset.announcement;
    if(!localStorage.getItem(key)) bar.hidden = false;
    var close = bar.querySelector('[data-announcement-close]');
    if(close) close.addEventListener('click', function(){
      bar.hidden = true;
      localStorage.setItem(key, '1');
    });
  }
});

// Sticky mobile add-to-cart: show when the main buy button scrolls out of view
document.addEventListener('DOMContentLoaded', function(){
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('.product-form');
  if(!sticky || !mainForm) return;
  sticky.hidden = false;
  var io = new IntersectionObserver(function(entries){
    sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
  }, { rootMargin: '-80px 0px 0px' });
  io.observe(mainForm);

  var mainSelect = document.querySelector('[data-product-variant-select]');
  var stickySelect = document.querySelector('[data-sticky-variant-select]');
  if(mainSelect && stickySelect){
    mainSelect.addEventListener('change', function(){ stickySelect.value = mainSelect.value; });
    stickySelect.addEventListener('change', function(){
      mainSelect.value = stickySelect.value;
      mainSelect.dispatchEvent(new Event('change'));
    });
  }
});

document.addEventListener('click', function(e){
  const toggle = e.target.closest('[data-mobile-toggle]');
  if(!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if(nav) nav.hidden = !nav.hidden;
});

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));

    function showMedia(mediaId){
      if(!mediaId) return;

      slides.forEach(function(slide){
        const active = slide.dataset.mediaId === String(mediaId);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);

        if(!active){
          slide.querySelectorAll('video').forEach(function(video){ video.pause(); });
        }
      });

      thumbnails.forEach(function(thumbnail){
        const active = thumbnail.dataset.mediaId === String(mediaId);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbnails.forEach(function(thumbnail){
      thumbnail.addEventListener('click', function(){
        showMedia(thumbnail.dataset.mediaId);
      });
    });

    const product = gallery.closest('.main-product');
    const variantSelect = product && product.querySelector('[data-product-variant-select]');
    if(variantSelect){
      variantSelect.addEventListener('change', function(){
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const mediaId = selectedOption && selectedOption.dataset.featuredMediaId;
        if(mediaId) showMedia(mediaId);
      });
    }
  });
});

// V2: staggered letter reveal on hero headlines
document.addEventListener('DOMContentLoaded', function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.hero-slide h1, .hero-slide .h1').forEach(function(h){
    var text = h.textContent;
    h.textContent = '';
    var i = 0;
    text.split('').forEach(function(ch){
      if(ch.trim() === ''){ h.appendChild(document.createTextNode(ch)); return; }
      var s = document.createElement('span');
      s.className = 'lr';
      s.style.setProperty('--i', i++);
      s.textContent = ch;
      h.appendChild(s);
    });
  });
});

// V2: animated stat counters
document.addEventListener('DOMContentLoaded', function(){
  var nums = document.querySelectorAll('[data-count-to]');
  if(!nums.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function(el, val){
    var out = String(Math.round(val));
    if(el.dataset.pad === 'true') out = out.padStart(3, '0');
    el.textContent = out + (el.dataset.suffix || '');
  };
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      var el = entry.target, target = Number(el.dataset.countTo) || 0;
      io.unobserve(el);
      if(reduce){ fmt(el, target); return; }
      var start = null;
      var step = function(t){
        if(!start) start = t;
        var p = Math.min((t - start) / 1200, 1);
        fmt(el, target * (1 - Math.pow(1 - p, 3)));
        if(p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }, { threshold: .6 });
  nums.forEach(function(el){ io.observe(el); });
});

// V2: custom cursor (fine pointers only)
document.addEventListener('DOMContentLoaded', function(){
  var cursor = document.querySelector('[data-cursor]');
  if(!cursor || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var x = 0, y = 0, cx = 0, cy = 0, active = false;
  document.addEventListener('mousemove', function(e){
    x = e.clientX; y = e.clientY;
    if(!active){ active = true; document.body.classList.add('cursor-active'); }
  }, { passive: true });
  var raf = function(){
    cx += (x - cx) * .2; cy += (y - cy) * .2;
    cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  document.addEventListener('mouseover', function(e){
    cursor.classList.toggle('is-link', !!e.target.closest('a, button, summary, select, input'));
  }, { passive: true });
});


// AJAX cart drawer: opens after add-to-cart and supports quantity changes.
document.addEventListener('DOMContentLoaded', function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  var content = drawer.querySelector('[data-cart-content]');
  var footer = drawer.querySelector('[data-cart-footer]');
  var subtotal = drawer.querySelector('[data-cart-subtotal]');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD'}).format(cents / 100); }
    catch(e){ return '$' + (cents / 100).toFixed(2); }
  }
  function escapeHtml(value){
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }
  function updateCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
  }
  function openDrawer(){
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');
  }
  function closeDrawer(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');
  }
  function render(cart){
    updateCount(cart.item_count);
    if(!cart.items.length){
      content.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      footer.hidden = true;
      return;
    }
    content.innerHTML = cart.items.map(function(item, index){
      var image = item.image ? '<img class="cart-drawer__image" src="' + escapeHtml(item.image) + '&width=180" alt="' + escapeHtml(item.product_title) + '">' : '<div class="cart-drawer__image"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-drawer__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      return '<div class="cart-drawer__item">' + image +
        '<div><a class="cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="cart-drawer__quantity"><button type="button" data-cart-change="' + (index + 1) + '" data-quantity="' + Math.max(0,item.quantity-1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change="' + (index + 1) + '" data-quantity="' + (item.quantity+1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="cart-drawer__price">' + money(item.final_line_price) + '</div></div>';
    }).join('');
    subtotal.textContent = money(cart.total_price);
    footer.hidden = false;
  }
  function getCart(){
    return fetch(root + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ if(!r.ok) throw new Error('Cart could not load'); return r.json(); }).then(render);
  }

  document.addEventListener('click', function(e){
    var opener = e.target.closest('[data-cart-open]');
    if(opener){ e.preventDefault(); openDrawer(); content.innerHTML='<p class="cart-drawer__status">Loading…</p>'; getCart().catch(function(){ window.location.href=opener.href; }); return; }
    if(e.target.closest('[data-cart-close]')){ closeDrawer(); return; }
    var changer = e.target.closest('[data-cart-change]');
    if(changer){
      changer.disabled=true;
      fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(changer.dataset.cartChange),quantity:Number(changer.dataset.quantity)})})
        .then(function(r){ if(!r.ok) throw new Error('Cart update failed'); return r.json(); }).then(render).catch(getCart);
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var button=form.querySelector('[type="submit"]');
      var oldText=button ? button.textContent : '';
      if(button){ button.disabled=true; button.textContent='Adding…'; }
      fetch(root + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){ if(!r.ok) return r.json().then(function(x){ throw new Error(x.description || 'Could not add item'); }); return r.json(); })
        .then(function(){ return getCart(); })
        .then(openDrawer)
        .catch(function(err){ alert(err.message); })
        .finally(function(){ if(button){ button.disabled=false; button.textContent=oldText; } });
    });
  });
});
